export default __webpack_public_path__ + "static/media/reddit.da9213ce.svg";